// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

const isProduction = process.env.NODE_ENV === "production";

if (isProduction) {
	import("./lib/observability/browser")
		.then(({ initializeBrowserMonitoring }) => initializeBrowserMonitoring())
		.catch(() => {
			// Ignore telemetry initialization failures on the client.
		});
}

export const onRouterTransitionStart = (...args: unknown[]) => {
	if (!isProduction) {
		return;
	}

	import("./lib/observability/browser")
		.then(({ captureRouterTransitionStart }) => {
			captureRouterTransitionStart(
				...(args as Parameters<typeof captureRouterTransitionStart>),
			);
		})
		.catch(() => {
			// Ignore telemetry errors.
		});
};
